import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'dda-reject-department-dialog',
  templateUrl: './reject-department-dialog.component.html',
  styleUrls: ['./reject-department-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RejectDepartmentDialogComponent implements OnInit {
 remark: string = ''
  constructor(public dialogRef: MatDialogRef<RejectDepartmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close(); // Close without passing data
  }

  onSubmit(): void {
    console.log(this.remark,"jej")
    this.dialogRef.close(this.remark); // Pass the remark back
  }
}


